import React from 'react';
import CastForEducationIcon from '@mui/icons-material/CastForEducation';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
// import SettingsIcon from '@mui/icons-material/Settings';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import * as Const from '../../utils/Const';

const SidebarData = [
  { title: Const.LabelSidebarTrainingTitle, icon: <CastForEducationIcon />, link: '/dashboard' },
  {
    title: Const.LabelSidebarSelfStudyTitle,
    icon: <QueryStatsIcon />,
    link: '/dashboard_selfstudy_admin',
  },
  // { title: '設定', icon: <SettingsIcon />, link: '/setting' },
  { title: Const.LabelCsvDownloadLink, icon: <FileDownloadIcon />, link: '/downloadcsv' },
];

export default SidebarData;
